import React from 'react';

const Repeat = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 14 14"
  >
    <path
      fill="#FFF"
      d="M6.578.902a.643.643 0 00-.017-.589.59.59 0 00-.822-.23L4.68.717a.638.638 0 00-.135.971l.815.885a.59.59 0 00.85.021.632.632 0 00.186-.432c1.404.578 2.4 1.997 2.4 3.656 0 2.17-1.703 3.935-3.796 3.935S1.204 7.987 1.204 5.817c0-1.519.857-2.918 2.183-3.564.3-.146.43-.518.289-.83a.593.593 0 00-.801-.299C1.128 1.975 0 3.817 0 5.817 0 8.675 2.243 11 5 11s5-2.325 5-5.183C10 3.53 8.563 1.589 6.578.902z"
    />
  </svg>
);

export default Repeat;
